import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	CreateOrUpdateDisplayPreferenceMutation,
	CreateOrUpdateDisplayPreferenceMutationVariables,
} from "~/types/__generated/gql/graphql";
import { meQueryKey } from "../useMe";

const query = /* GraphQL */ `
	mutation CreateOrUpdateDisplayPreference(
		$input: UserDisplayPreferenceInput!
	) {
		createOrUpdateDisplayPreference(input: $input) {
			agent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			client {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					info {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					addresses {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					contacts {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
					service {
						sortingIndex
						fields {
							parentFieldName
							fieldName
							fieldLabel
							fieldType
							sortingIndex
							isCustomField
							isPinned
							width
						}
					}
				}
			}
			product {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			serviceAgent {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			serviceClient {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
			}
			accountTransaction {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					sections {
						name
						sortingIndex
						display
						rows {
							sortingIndex
							fields {
								sortingIndex
								id
								isVisible
							}
						}
					}
				}
			}
			file {
				_id
				type
				isTemplate
				list {
					parentFieldName
					fieldName
					fieldLabel
					fieldType
					sortingIndex
					isCustomField
					isPinned
					isVisible
					width
				}
				form {
					sections {
						name
						sortingIndex
						display
						rows {
							sortingIndex
							fields {
								sortingIndex
								id
								isVisible
							}
						}
					}
				}
			}
		}
	}
`;

export type CreateOrUpdateDisplayPreferenceVariables =
	CreateOrUpdateDisplayPreferenceMutationVariables;
export type CreateOrUpdateDisplayPreferenceResults =
	CreateOrUpdateDisplayPreferenceMutation["createOrUpdateDisplayPreference"];

export const useCreateOrUpdateDisplayPreference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: CreateOrUpdateDisplayPreferenceVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.createOrUpdateDisplayPreference),
		onSuccess: (_) => {
			void queryClient.invalidateQueries(meQueryKey());
		},
	});
};
